import { useMemo } from 'react';
import { useTranslate, usePageTitle } from '../../../hooks/usePageTitle';
import { useIsEnabledLanguageInRequests } from './useIsEnabledLanguageInRequests';
import { NAMESPACES } from '../../../constants/namespaces';

export const useTranslationMetaTags = () => {
  const isEnabledLanguageInRequest = useIsEnabledLanguageInRequests();

  // Hack for prevent loading of translation of meta tags when it does not needed
  const namespace = !isEnabledLanguageInRequest
    ? NAMESPACES.META_TAGS
    : NAMESPACES.INITIAL;

  const translate = useTranslate(namespace);
  const title = usePageTitle();

  return useMemo(() => {
    const interpolation = title ? { pageName: title } : {};

    return (value) =>
      !isEnabledLanguageInRequest ? translate(value, interpolation) : value;
  }, [translate, title, isEnabledLanguageInRequest]);
};
